import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import Button from "@material-ui/core/Button/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton/IconButton";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import {Translate} from "../../../../config/Translate";
import AddBox from "@material-ui/icons/AddBox";
import TextField from "@material-ui/core/TextField";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {updateRedux} from "../../../../config/Security";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import CreateNewFolderRoundedIcon from '@material-ui/icons/CreateNewFolderRounded';
import {connect} from "trim-redux";

class AddDirectoryButton extends React.Component {
    state = {
        open:false,
        name: "",
        SubmitLoading:false,
    };
    handleRequest(){
        this.setState({
            SubmitLoading:true,
        });
        const {name} = this.state;
        const {current_directory} = this.props;
        let data = new FormData();
        data.append('name', name);
        data.append('current_directory', current_directory);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/file-directory/make`, data, config)
            .then(response => {
                this.setState({
                    SubmitLoading:false,
                    open:false,
                });
                this.props.reload();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                    variant: 'error',
                });
                this.setState({
                    SubmitLoading:false
                });
            });
    }
    render(){
        let {open,name,SubmitLoading} = this.state;
        let {empty,button} = this.props;
        return(
            <>
                {
                    button ?
                        <Tooltip
                            title={Translate.addDirectory}
                        >
                            <IconButton
                                color="primary"
                                variant="contained"
                                size="small"
                                style={{marginBottom:10}}
                                onClick={() => this.setState({open: !this.state.open})}
                            >
                                <CreateNewFolderRoundedIcon/>
                            </IconButton>
                        </Tooltip>
                        :
                        <div style={{textAlign:"center"}}>
                        <Button
                            variant="contained"
                            size="small"
                            style={{backgroundColor:"#fff",color:this.state.primary_color}}
                            onClick={() => this.setState({open: !this.state.open})}
                        >
                            {Translate.addDirectory}
                        </Button>
                        </div>
                }
                <Dialog  fullWidth maxWidth="xs"  open={open} onClose={() => this.setState({open: !this.state.open})} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">
                        {Translate.addDirectory}
                        <IconButton aria-label="close" className="modal-close-btn"  onClick={() => this.setState({open: !this.state.open})}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            variant="outlined"
                            value={name}
                            fullWidth
                            size="small"
                            label={Translate.directoryName}
                            onChange={(e) => this.setState({name:e.target.value})}
                        />
                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            disabled={name.length < 3}
                            onClick = {this.handleRequest.bind(this)}
                            loading = {SubmitLoading}
                        >
                            {Translate.addDirectory}
                        </LoadingButton>
                    </DialogContent>
                </Dialog>
            </>

        )
    }
}
const mstp = state => ({
    primary_color: state.primary_color
});
export default withWidth()(withSnackbar(withStyles(Styles)(connect(mstp)(AddDirectoryButton))));
